export const LOGIN_REDIRECT_URI = '/login';
